
import Dialog from '@mui/material/Dialog';
import ErrorIcon from '../assets/icons/ErrorIcon.svg?react';
import XButton from '../components/common/XButton';

const containerClasses = 'rounded bg-surface p-6 max-w-175 w-full';
const headingClasses =
    "font-['Open_Sans',serif] text-warning text-2xl font-semibold leading-9 ml-2 mb-0";
const listClasses = 'list-none p-0 mt-6 mb-4';
const itemClasses =
    'px-4 py-2 rounded border border-warning bg-danger-surface mb-2';
const itemHeadingClasses = 'font-bold text-warning';
const itemInfoClasses = 'text-content mb-0';

const FileUploadErrorModal = ({fileErrorList,setFileErrorList}) => {
    const handleClose = () => {
        setFileErrorList([]);
    };

    function bytesToMB(bytes) {
        return (bytes / (1024 * 1024)).toFixed(2);
    }

    return (
        <Dialog
        open={fileErrorList.length ? true : false} 
        onClose={handleClose}
        sx={{ "& .MuiDialog-paper": { maxWidth: "700px", width: "100%", backgroundColor: "var(--color-surface)" } }}
        >
            <div className={containerClasses}>
                <div className="flex items-center">
                <ErrorIcon/>
                <h2 className={headingClasses}>Files failed to upload. </h2>
                </div>
                <ul className={listClasses}>
                    {fileErrorList.map((item)=>{
                       
                        return (
                            <li className={itemClasses} key={item.fileName}>
                                <h6 className={itemHeadingClasses}>{item.fileName}</h6>
                                    <p className={itemInfoClasses}>
                                        {item?.fileSize === 0 && "Error: File is 0 bytes, file cannot be empty"}
                                        {item?.isFileLarge && `Error: File is ${bytesToMB(item?.fileSize)} MB, must be less than ${bytesToMB(item?.maxSize ?? 500 * 1024 * 1024)} MB`}
                                        {item?.type && `Error: File type is ${item.type.split('/')[1]}, it must be "jpg", "jpeg", "png", or "heic"`}
                                        {item?.fileTypeError && "Error: Wrong file type, must be PDF"}
                                        {item?.isPasswordProtected && `Given Pdf file is password protected`}
                                    </p>
                            </li>
                        )
                    })}
                </ul>
                <div className="text-right">
                    <XButton onClick={handleClose}>
                        OK
                    </XButton>
                </div>
            </div>
        </Dialog>
    )
}

export default FileUploadErrorModal;